@if (!authService.isAuthenticated) {

<div class="flex items-center justify-center min-h-screen bg-metro-blue">
  <div class="w-full p-3 md:max-w-md md:bg-white md:rounded-xl md:shadow-lg md:p-8 mt-12 relative animate-fade-in">

    <!-- Icono principal -->
     @if (!hasError && !isSuccess) {
    <div  class="flex flex-col items-center gap-4">
      <div class="animate-spin h-10 w-10 border-4 border-gray-300 border-t-metro-blue rounded-full"></div>
      <p class="text-gray-700 text-sm">{{ '::ConfirmingEmail' | abpLocalization }}</p>
    </div>
  }

     @if (isSuccess) {
    <div  class="flex flex-col items-center gap-4">
      <div class="h-16 w-16 flex items-center justify-center rounded-full bg-green-100 animate-scale-in">
        <svg class="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                d="M5 13l4 4L19 7"/>
        </svg>
      </div>
      <p class="text-green-700 font-semibold text-lg">{{ '::EmailConfirmed' | abpLocalization }}</p>
      <p class="text-gray-500 text-sm">{{ '::RedirectingToLogin' | abpLocalization }}</p>
    </div>}

     @if (hasError) {
    <div  class="flex flex-col items-center gap-4">
      <div class="h-16 w-16 flex items-center justify-center rounded-full bg-red-100 animate-scale-in">
        <svg class="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
      <p class="text-red-600 font-semibold text-lg">{{ '::EmailConfirmationError' | abpLocalization }}</p>
      <button class="mt-2 px-4 py-2 rounded-lg bg-metro-blue text-white hover:bg-metro-secondary"
              (click)="router.navigate(['/account/login'])">
        {{ '::BackToLogin' | abpLocalization }}
      </button>
    </div>
  }
  </div>
</div>
}
